<div
  class="waveseparator z-30"
  [class]="{
    'waveseparator-bottom': offset === 'bottom',
    'waveseparator-top': offset === 'top'
  }"
  [style]="animationDurationtyle"
></div>
